import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Entrance from "./components/Entrance";
import Intro from "./components/Intro";
import Categories from "./components/Categories";
import Popular from "./components/Popular";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Entrance />
        <Intro />
        <Categories />
        <Popular />
        <Guide />
        <Faq />
        <Testimonials />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}